import { TemplateFilter } from 'dashboard/lib/workflows/objects';
import { Trigger } from 'dashboard/models/trigger';
import { BlockInput } from 'dashboard/models/workflow-block';
import {
  INPUT_STEP_TOKEN,
  WorkflowStepInput,
  WorkflowStepType,
} from 'dashboard/models/workflow-version';

export const createInputStep = ({
  trigger,
  filter,
  inputs = [],
}: {
  trigger?: Trigger;
  filter?: TemplateFilter;
  inputs?: BlockInput[];
}): WorkflowStepInput => {
  return {
    type: WorkflowStepType.Input,
    name: 'Input Step',
    token: INPUT_STEP_TOKEN,
    trigger,
    inputs,
    filter,
  };
};
